var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "dot-11",
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.3,5.5A4.2,4.2,0,1,0,5.5,1.3,4.2,4.2,0,0,0,1.3,5.5",
    fill: "hsl(20, 17%, 100%)",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.8,5.5a3.7,3.7,0,0,0,7.4.0021V5.5a3.7,3.7,0,0,0-7.4-.0009V5.5",
    fill: "hsl(20, 17%, 100%)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.3,5.5a3.2,3.2,0,0,0,6.4.0022V5.5a3.2,3.2,0,0,0-6.4-.0013V5.5",
    fill: "hsl(20, 17%, 100%)",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.8,5.5a2.7,2.7,0,0,0,5.4.0018V5.5a2.7,2.7,0,0,0-5.4-.0009V5.5",
    fill: "hsl(20, 17%, 100%)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.3,5.5a2.2,2.2,0,0,0,4.4.0014V5.5a2.2,2.2,0,0,0-4.4,0",
    fill: "hsl(352,100%, 50%)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDot);
export default __webpack_public_path__ + "static/media/dot.1a654f8b63b3b8f6f47d5d0a6edc4db3.svg";
export { ForwardRef as ReactComponent };